
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Datakilde',
	'dataSourceId': 'ID',
	'dataSourceType': 'Type',
	'dataSourceName': 'Navn',
	'dataSourcePath': 'Bane',
	'showInfoForAll': 'Vis varighet for alle visualiseringer',
	'hideInfoForAll': 'Skjul varighet for alle visualiseringer',
	'showPerformanceDetails': 'Kjør alle widgeter på nytt for å inkludere ytelsesdetaljer',
	'slotMappingField': 'Sportilordninger',
	'slotDataMapping': 'Tilordning',
	'slotID': 'ID',
	'slotCaption': 'Tittel',
	'slotMandatory': 'Obligatorisk',
	'slotIsMandatory': 'Ja',
	'slotIsNotMandatory': 'Nei',
	'infoNotAvailable': 'Ikke tilgjengelig',
	'performanceSection': 'Ytelse',
	'durationField': 'Varighet',
	'singleQueryTime': 'Serverspørring (ms)',
	'multipleQueryTime': 'Serverspørring %{name} (ms)',
	'liveWidgetTotalTime': 'Totalt (ms)',
	'renderTimeNotAvailable': 'Ikke tilgjengelig',
	'renderInProgress': '(pågår)',
	'interactToTriggerQuery': 'Arbeid med widget for å utløse en spørring',
	'fetchQuery': 'Hent spørring',
	'showSQLMDX': 'Vis SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Spørringsinformasjon',
	'queryInfoNotAvailable': 'Spørringsinformasjon ikke tilgjengelig',
	'query': 'Spørring',
	'copy': 'Kopier',
	'close': 'Lukk'
});
